import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[typewriteEffectText]',
    standalone: true
})
export class TypewriteEffectTextDirective implements OnInit {
    @Input() typewriteEffectText?: string;

    constructor(public elementRef: ElementRef) {}

    ngOnInit(): void {
        const text = this.elementRef.nativeElement.innerText || this.typewriteEffectText;
        let output = '';

        text.split('').forEach((letter: string) => {
            output += `<span>${letter}</span>`;
        });

        this.elementRef.nativeElement.innerHTML = output;
    }
}
